/* eslint-disable import/no-cycle */
import { takeLatest } from 'redux-saga/effects';
import {
  handleGenerateOTP, handleGetUserDetails,
  handleVerifyOTP, handleVerifyPrevTokenAndGetUserDetails, handleResendOtpMobile, handleSetPreviousStep,
} from './accountHandlers';
import {
  generateOTP, getUserDetails, verifyOTP, verifyPrevTokenAndGetUserDetails, resendOtp, previousStep,
} from './accountSlice';

export function* generateOTPSaga() {
  yield takeLatest(generateOTP.type, handleGenerateOTP);
}
export function* resendOtpMobileSaga() {
  yield takeLatest(resendOtp.type, handleResendOtpMobile);
}

export function* verifyOTPSaga() {
  yield takeLatest(verifyOTP.type, handleVerifyOTP);
}

export function* getUserDetailsSaga() {
  yield takeLatest(getUserDetails.type, handleGetUserDetails);
}

export function* verifyPrevTokenAndGetUserDetailsSaga() {
  yield takeLatest(verifyPrevTokenAndGetUserDetails.type, handleVerifyPrevTokenAndGetUserDetails);
}

export function* setPreviousStepSaga() {
  yield takeLatest(previousStep.type, handleSetPreviousStep);
}
